import { SwatchRGB } from "../swatch.js";
/**
 * A {@link SwatchRGB} convenience for white.
 *
 * @internal
 */
export const _white = new SwatchRGB(1, 1, 1);
/**
 * A {@link SwatchRGB} convenience for black.
 *
 * @internal
 */
export const _black = new SwatchRGB(0, 0, 0);
